// Node modules
import {
  Container,
  ITween,
  ingenuity,
  killDelayedCall,
  dispatcher,
  SpineBase,
  Meter,
  delayedCall,
} from "@quest/base-core";

// Game moduels
import { HoldAndReSpinView } from "../View/HoldAndReSpinView";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { gameConstants } from "../../Constants/gameConstants";
import { GameParserModel } from "../../Platform/GameParserModel";
import { HoldAndRespinReelModel } from "../Model/HoldAndRespinReelModel";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";

export class HoldAndReSpinCounterController {
  private view: HoldAndReSpinView;
  private model: HoldAndRespinReelModel;
  private spinActiveCont: Container;
  private tweenCoins: ITween;
  private tweenCoin_1: ITween;
  private grandJackpotMeter: Meter;
  private majorJackpotMeter: Meter;
  private minorJackpotMeter: Meter;
  private miniJackpotMeter: Meter;
  private spinCounterAnim: SpineBase;
  private isRunning: boolean = false;
  private currentCounter: number = 3;

  /**
   * Class constructor
   * @param view
   * @param model
   */
  constructor(view: HoldAndReSpinView, model: HoldAndRespinReelModel) {
    this.view = view;
    this.model = model;
    this.initializeElements();
    this.subscribeEvents();
  }

  /**
   * Method for initializing UI elemtent for this class
   */
  private initializeElements(): void {
    this.spinActiveCont = this.view.getContainerByID("spinActiveContainer");
    this.spinCounterAnim = this.view.getSpineById("Bonus_game_spin_counter") as SpineBase;
    this.grandJackpotMeter = this.view.getMeterById("grandMeterText") as Meter;
    this.majorJackpotMeter = this.view.getMeterById("majorMeterText") as Meter;
    this.minorJackpotMeter = this.view.getMeterById("minorMeterText") as Meter;
    this.miniJackpotMeter = this.view.getMeterById("miniMeterText") as Meter;
    this.updateJackpotMeterValues();
  }

  /**
   * updateJackpotMeterValues method set Jackpot Meters Values
   */
  private updateJackpotMeterValues(): void {
    let currentBet: number = ingenuity.parserModel.getCurrentTotalBet();
    const grandJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotData().grand; //update multiplier values from server - dependancy
    const majorJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotData().major;
    const minorJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotData().minor;
    const miniJackpot = currentBet * (ingenuity.parserModel as GameParserModel).getJackpotData().mini;
    this.grandJackpotMeter.setCurrencyFormattedValue(grandJackpot.toString());
    this.majorJackpotMeter.setCurrencyFormattedValue(majorJackpot.toString());
    this.minorJackpotMeter.setCurrencyFormattedValue(minorJackpot.toString());
    this.miniJackpotMeter.setCurrencyFormattedValue(miniJackpot.toString());
  }

  /**
   * Method to subscribe events
   */
  private subscribeEvents(): void {
    this.unSubscribeEvents();
    dispatcher.on(eventDispatchers.UPDATED_COLLECTED_COINS, this.setCollectedCoinsCounter, this);
    dispatcher.on(eventDispatchers.UPDATE_SPIN_REMAINING_COUNT, this.showNextSpinLeftCounter, this);
    dispatcher.on(eventDispatchers.RESET_SPIN_LEFT_COUNTER, this.resetCurrentCounter, this);
    dispatcher.on(eventDispatchers.RESET_COUNTERS, this.resetCounters, this);
  }

  /**
   * Method to un-subscribe events
   */
  private unSubscribeEvents(): void {
    dispatcher.off(eventDispatchers.UPDATED_COLLECTED_COINS, this.setCollectedCoinsCounter, this);
    dispatcher.off(eventDispatchers.UPDATE_SPIN_REMAINING_COUNT, this.showNextSpinLeftCounter, this);
    dispatcher.off(eventDispatchers.RESET_SPIN_LEFT_COUNTER, this.resetCurrentCounter, this);
    dispatcher.off(eventDispatchers.RESET_COUNTERS, this.resetCounters, this);
  }

  /**
   * to update collected coins counter
   */
  private setCollectedCoinsCounter(): void {
    this.model.setTotalLockedCoins(this.model.getStoppedReels().length);
  }
 /**
  * play sound for spin couner as per current counter
  */
  private playSoundCounter(): void {
    switch (this.currentCounter) {
      case 3:
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.RESPIN_COUNT_DOWN_3,
          1,
          false,
          SlotConstantsBehavior.SOUND_LIST_POSTLOAD
        );
        break;
      case 2:
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.RESPIN_COUNT_DOWN_2,
          1,
          false,
          SlotConstantsBehavior.SOUND_LIST_POSTLOAD
        );
        break;
      case 1:
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.RESPIN_COUNT_DOWN_1,
          1,
          false,
          SlotConstantsBehavior.SOUND_LIST_POSTLOAD
        );
        break;
      default:
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.RESPIN_COUNT_DOWN_1,
          1,
          false,
          SlotConstantsBehavior.SOUND_LIST_POSTLOAD
        );
        break;
    }
  }

  /**
   * to decreases the counter after every spin
   */
  private showNextSpinLeftCounter(): void {
    this.disableSpinLeftCounter();
    if (this.currentCounter === 3) {
      this.playTextShineAnimation();
    }
    this.playSoundCounter();
    if (this.currentCounter) {
      let activeCountCon = this.view.getImageById("spinActiveBG_" + this.currentCounter);
      let fireEffect = this.view.getSpineById("activeCounterSpine");
      fireEffect.visible = true;
      delayedCall('showcounter',10,()=>{
        killDelayedCall('showcounter')
        this.view.getContainerByID(gameConstants.SPIN_ACTIVE_COUNT + this.currentCounter).visible = true;
        this.currentCounter--;
      })
      fireEffect.x = activeCountCon.x + gameConstants.ADDED_POSITION;
      fireEffect.y = activeCountCon.y + gameConstants.ADDED_POSITION;
      fireEffect.playAnim('glow_effect',true);
    }
  }
  /**
   * to play the shine animation behind the text of remaining spins
   */
  private playTextShineAnimation(): void {
    if (!this.isRunning) {
      this.isRunning = true;
      this.spinCounterAnim.visible = true;
      this.spinCounterAnim.playAnim("reSpin_glow_effect");
      this.spinCounterAnim.onComplete.addOnce(() => {
        this.isRunning = false;
        this.spinCounterAnim.visible = false;
      }, this);
    }
  }
  /**
   * reset counter to 3 whenever any symvol lands
   */
  private resetCurrentCounter(): void {
    this.currentCounter = 3;
    this.showNextSpinLeftCounter();
  }
  /**
   * to disable all spin left counters
   */
  private disableSpinLeftCounter(): void {
    this.spinActiveCont.forEach((contaner: Container) => {
      contaner.visible = false;
    });
  }

  /**
   * to reset coins
   */
  protected resetCounters(): void {
    killDelayedCall("nextSymbolShowDelay");
    ingenuity.currentGame.tweens.remove(this.tweenCoin_1);
    ingenuity.currentGame.tweens.remove(this.tweenCoins);
    this.currentCounter = 3;
  }
}
